module.exports = __webpack_public_path__ + "media/images/search-detail-f7e689f420355bc4fe2004c96559f08c.jpg";